<div>
  <gstar-prime-grid-filter-toolbar [hasFilter]="hasFilters()" #toolbar>
    <div start-toolbar>
      <ng-content select="[start-toolbar-filter]"></ng-content>
    </div>
    <div center-toolbar>
      <ng-content select="[center-toolbar-filter]" />
    </div>
    <div end-toolbar>
      <ng-content select="[end-toolbar-filter]" />
    </div>
  </gstar-prime-grid-filter-toolbar>

  <ap-panel class="mb-3" [hidden]="toolbar.isCollapse()">
    <div class="p-2">
      <div class="mt-3 d-grid gap-3 portfolio-filter-grid">
        @for (filterColumn of filters(); track $index + filterColumn.key) {
          <gstar-grid-filter
            [filterColumn]="filterColumn"
            (updateFilter)="filterHandler($event)" />
        }
      </div>
      <div class="ap-panel-footer d-flex gap-2 justify-content-end">
        <ap-button
          class="mt-4 px-2"
          btnType="secondary"
          [compact]="true"
          [label]="'shared.clearAll' | translate"
          (onClick)="clearAndRun()" />
        @if (!triggerByChanges()) {
          <ap-button
            class="mt-4"
            [compact]="true"
            btnType="primary"
            [label]="'portfolio.applyFilter' | translate"
            (onClick)="applyFilter()" />
        }
      </div>
    </div>
  </ap-panel>
</div>
